module.exports = __webpack_public_path__ + "static/media/DinningArea-c.d3cfc1ff.webp";